import { BomPartNumber } from 'bom/elements';
import { IBomPart } from 'bom/types';

interface IProps {
  bomPart: IBomPart;
  onPartNumberClick?: (part: IBomPart) => void;
  isDeleted?: boolean;
}

export const PartTypePartContent = ({ bomPart, onPartNumberClick, isDeleted = false }: IProps) => {
  return <BomPartNumber bomPart={bomPart} onPartClick={onPartNumberClick} isDeleted={isDeleted} />;
};
